import React, { useState, useRef, useEffect } from "react";
import { TextField, Box, CircularProgress, Fade } from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import TooltipComponent from "../tooltip";
import InfoIcon from "@mui/icons-material/Info";

const CustomInput = ({
  onChange,
  styles = {},
  state = null,
  value,
  autoFocus = true,
  hideClear = false,
  showTooltip = false,
  tooltipText = "",
  showInputProgress = false,
  multiline = true,
  onEnterPressed = (r) => {},
  ...rest
}) => {
  const [inputState, setInputState] = useState(state);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // Get a reference to the input element
  const inputRef = useRef(null);
  useEffect(() => {
    // Focus the input element when the component mounts
    if (autoFocus && inputRef.current) {
      autoFocus && inputRef.current.focus();
    }
  }, []);
  useEffect(() => {
    // If the state is provided, use it
    // Otherwise use the value if it exists
    // if (state !== null) {
    //   return setInputState(state);
    // }
    // if (value && inputState === null) {
    //   return setInputState("success");
    // }
    setInputState(state);
  }, [state]);

  const handleChange = async (event) => {
    await (onChange && onChange(event));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <TextField
          {...rest}
          value={value || ""}
          multiline={multiline}
          // maxRows={2}
          inputRef={inputRef}
          onKeyDown={(keyDownEvent) => {
            const { keyCode } = keyDownEvent;
            if (keyCode === 13) {
              keyDownEvent.preventDefault();
              if (inputRef) {
                const nextInput = inputRef.current.nextElementSibling;
                const currentId = inputRef.current.id;
                if (currentId.includes("textTypeComponent")) {
                  const currentIndex = currentId.split("--")[1];
                  if (currentIndex) {
                    const nextInputElement = document.getElementById(
                      `textTypeComponent--${parseInt(currentIndex, 10) + 1}`
                    );
                    if (nextInputElement) {
                      nextInputElement.focus();
                    }
                  }
                }
                onEnterPressed && onEnterPressed(inputRef.current);
              }
            }
          }}
          onChange={handleChange}
          onBlur={() => {
            const ele = inputRef.current;
            if (ele) {
              setTimeout(() => {
                ele.scrollIntoView({
                  block: "center",
                });
              }, 600);
            }
          }}
          sx={{
            ...styles,
            "& .MuiInputBase-input": {
              paddingInlineEnd: "50px",
            },
          }}
        />
        {showInputProgress && (
          <>
            <Fade in={inputState == "loading"}>
              <CircularProgress
                size="16px"
                color="black"
                sx={{
                  position: "absolute",
                  // top: "20px",
                  right: "10px",
                }}
              />
            </Fade>
            <Fade in={inputState == "success"}>
              <CheckCircleOutlinedIcon
                sx={{
                  position: "absolute",
                  top: "17px",
                  right: "7px",
                  color: "green",
                  width: "22px",
                  height: "22px",
                }}
              />
            </Fade>
            <Fade in={inputState == "error"}>
              <CancelOutlinedIcon
                sx={{
                  position: "absolute",
                  top: "17px",
                  right: "7px",
                  color: "red",
                  width: "22px",
                  height: "22px",
                }}
              />
            </Fade>
          </>
        )}
      </Box>

      {showTooltip && (
        <div style={{ position: "absolute", top: "-25px", right: "0" }}>
          <TooltipComponent
            open={tooltipOpen}
            setOpen={setTooltipOpen}
            tooltipText={tooltipText}
          >
            <InfoIcon onClick={() => setTooltipOpen(true)} />
          </TooltipComponent>
        </div>
      )}

      {true /* this true will completely disabled clear button */ ||
        (!hideClear && value !== "" && (
          <div
            style={{
              width: "100%",
              alignItems: "flex-end",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              paddingRight: "8%",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                fontSize: "0.7rem",
                paddingTop: "10px",
              }}
              onClick={() => {
                handleChange({
                  target: {
                    value: "",
                  },
                });
              }}
            >
              Clear
            </span>
          </div>
        ))}
    </div>
  );
};

export default CustomInput;
